import { Observable } from 'rxjs';

export abstract class AbstractPesquisaProvider {

    public titulo: string;

    constructor() {
    }

    abstract getServico(): Observable<any>;

    abstract preencherDados(dados: any): any;

}
